import * as React from "react";
import { ICellEditorParams } from "ag-grid-community";
import { merge } from "glamor";
import DropdownSizesContainer from "./components/dropdown-sizes-container";
import _ from "lodash";
import { Item } from "constants/product-collection";
import { KEYBOARD_KEYS } from "constants/keyboard";
import { BLANK } from "./components/checkbox-list/checkbox-list-new-item";
import { ISizeRange } from "actions/collections";
import { DEFAULT_VALUES_PINNED_ROW } from "../../detail-list/helpers";

interface IDropdownSizesEditorProps extends ICellEditorParams {
    getMissingDependencies: (data) => string[];
    merchantId: string;
    delimiter: string;
    onSizeSelectedChanged?: (sizeZelected: string, sizeRanges?: ISizeRange[]) => void;
}

interface IDropdownSizesEditorState {
    value: string;
    missingDependencies: string[];
    defaultSelectedSizeRangeLabel?: string;
    shouldClearState?: boolean;
}

export class DropdownSizesEditor extends React.Component<IDropdownSizesEditorProps, IDropdownSizesEditorState> {
    private styles = merge({
        minWidth: "220px",
        width: this.props.eGridCell && this.props.eGridCell.style.width,
    });
    constructor(props) {
        super(props);

        let initValue = props.value || "";

        let defaultSelectedSizeRangeLabel;

        if (this.needsToClearCell()) {
            initValue = "";
        } else {
            defaultSelectedSizeRangeLabel = _.get(props.data, Item.FIELDS.SELECTED_SIZE_RANGE);
        }

        this.state = {
            missingDependencies: props.getMissingDependencies(props.data),
            value: initValue,
            defaultSelectedSizeRangeLabel,
        };
    }

    needsToClearCell() {
        const { eventKey } = this.props;

        return eventKey === KEYBOARD_KEYS.BACKSPACE || eventKey === KEYBOARD_KEYS.DELETE;
    }

    getFormattedValue() {
        const { delimiter } = this.props;
        return this.state.value
            .split(delimiter)
            .filter((valueItem) => valueItem.trim() !== "" && valueItem.trim() !== BLANK)
            .join(delimiter);
    }

    getValue() {
        return this.getFormattedValue();
    }

    isPopup(): boolean {
        return true;
    }

    handleChange = (value: string, sizeRanges?: ISizeRange[]) => {
        const { onSizeSelectedChanged } = this.props;
        this.setState({ value });
        if (onSizeSelectedChanged) {
            onSizeSelectedChanged(value, sizeRanges);
        }
    };

    render() {
        const { merchantId, delimiter, data, eGridCell } = this.props;
        const { value, missingDependencies, defaultSelectedSizeRangeLabel, shouldClearState } = this.state;

        return (
            <div {...this.styles}>
                <DropdownSizesContainer
                    value={value}
                    missingDependencies={missingDependencies}
                    onChange={this.handleChange}
                    merchantId={merchantId}
                    delimiter={delimiter}
                    shouldClearState={shouldClearState}
                    itemId={
                        data?.type !== DEFAULT_VALUES_PINNED_ROW
                            ? _.get(data, Item.FIELDS.ID)
                            : DEFAULT_VALUES_PINNED_ROW
                    }
                    defaultSelectedSizeRangeLabel={defaultSelectedSizeRangeLabel}
                    eGridCell={eGridCell}
                />
            </div>
        );
    }
}
